import { toastr } from 'react-redux-toastr';
import * as types from './types';
import { actionCreator, generalActionTypes,extractErrorMessages } from '@bit/wavfichacerta.fichacerta.utils.redux-utils';
import { requests, requestsSolicitation } from '../../../../services/operational';
import { replace } from 'connected-react-router';
import { LOGOUT_SUCCESS } from '../../../../pages/auth/login/actions/types.js';

const { NON_HANDLED_ERROR } = generalActionTypes;

export const changePage = (page) => actionCreator(types.CHANGE_PAGE, page)
export const changePerPage = (perPage) => actionCreator(types.CHANGE_PER_PAGE, perPage)
export const onChangeSort = (order) => actionCreator(types.CHANGE_SORT, order)
export const setFilter = (filter) => actionCreator(types.SET_FILTER, filter)
export const setFinalDate = (date) => actionCreator(types.SET_FINAL_DATE, date)
export const setStartDate = (date) => actionCreator(types.SET_START_DATE, date)
export const resetRequests = () => actionCreator(types.RESET_REQUESTS)

export const getRequests = () => {
  return async (dispatch, getState) => {
    dispatch(actionCreator(types.REQUESTS_LOADING));
    try {
      const { login: { user: { token } }, requestsTable: {pagination} } = getState();
      const payload = await requests(token.access_token, pagination);
      if (payload.status !== 200) {
        if (payload.status === 401) {
          dispatch(actionCreator(LOGOUT_SUCCESS));
          dispatch(replace('/auth'));
        } else {
          toastr.warning('Solicitações', extractErrorMessages(payload.data.message));
          dispatch(actionCreator(types.REQUESTS_ERROR));
        }
      } else {
        dispatch(actionCreator(types.REQUESTS_DONE, payload.data));
      }
    } catch (error) {
      dispatch(actionCreator(NON_HANDLED_ERROR, 'Não foi possível processar a informação no momento.'));
      dispatch(actionCreator(types.REQUESTS_ERROR));
    }
  }
}

export const getRequestsSolicitation = () => {
  return async (dispatch, getState) => {
    dispatch(actionCreator(types.REQUESTS_LOADING));
    try {
      const { login: { user: { token } }, requestsTable: {pagination} } = getState();
      const payload = await requestsSolicitation(token.access_token, pagination);
      if (payload.status !== 200) {
        if (payload.status === 401) {
          dispatch(actionCreator(LOGOUT_SUCCESS));
          dispatch(replace('/auth'));
        } else {
          toastr.warning('Solicitações', extractErrorMessages(payload.data.message));
          dispatch(actionCreator(types.REQUESTS_ERROR));
        }
      } else {
        dispatch(actionCreator(types.REQUESTS_DONE, payload.data));
      }
    } catch (error) {
      dispatch(actionCreator(NON_HANDLED_ERROR, 'Não foi possível processar a informação no momento.'));
      dispatch(actionCreator(types.REQUESTS_ERROR));
    }
  }
}